import styled, { css } from 'styled-components/macro';
import autobg from 'autobg.macro';
import vw from 'rpf/un/vw';
import LongPage from 'rpf/react/components/LongPage';

export const Wrap = styled(LongPage)`
  position: relative;
  ${p =>
    p.type === 'master'
      ? css`
          background-color: #e84a52;
        `
      : css`
          background-color: #ffffff;
        `}
`;

export const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding-bottom: ${vw(60)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MasterBg = styled.div`
  ${autobg('assets/img/card/bg_master.jpg')};
`;

const masterInfo = [
  autobg('assets/img/card/master_shijie.png'),
  autobg('assets/img/card/master_jinka.png'),
  autobg('assets/img/card/master_baijin.png'),
  autobg('assets/img/card/master_feiren.png')
];
export const MasterInfo = styled.div`
  ${p => masterInfo[p.card]}
  margin-top: ${vw(585)};
`;

export const MasterLinkBtn = styled.div`
  ${autobg('assets/img/card/btn_master.png')}
  margin-top: ${vw(62)};
`;

export const MasterReturnBtn = styled.div`
  margin-top: ${vw(26)};
  padding-bottom: ${vw(10)};
  font-size: ${vw(30)};
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
`;

const visaInfo = [
  autobg('assets/img/card/visa_baijin.jpg'),
  autobg('assets/img/card/visa_jinka.jpg'),
  autobg('assets/img/card/visa_hei.jpg'),
  autobg('assets/img/card/visa_blue.jpg')
];
export const VisaBg = styled.div`
  ${p => visaInfo[p.card]}
`;

export const VisaLinkBtn = styled.div`
  ${autobg('assets/img/card/btn_visa.png')}
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${vw(140)};
  margin: 0 auto;
`;

export const VisaReturnBtn = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${vw(86)};
  width: fit-content;
  margin: 0 auto;
  padding-bottom: ${vw(10)};
  font-size: ${vw(30)};
  color: #2b4bab;
  border-bottom: 1px solid #2b4bab;
`;
